import React from 'react';
import ReactDOM from 'react-dom';

import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';

import * as serviceWorker from './serviceWorker';
import App from './App';
import PartnerApp from './partner/PartnerApp';
import reducers from './store/reducers';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/styles.css';

const store = createStore(reducers, applyMiddleware(logger, thunk));

const isPartnerPortal = window.location.pathname.startsWith('/partners');

ReactDOM.render(
    isPartnerPortal ? (
        <PartnerApp />
    ) : (
        <Provider store={store}>
            <App />
        </Provider>
    ),
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
